// src/pages/About.jsx
import React from 'react';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import { PageTitle } from '../styles/SharedStyles';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-grow: 1;
`;

const TextSection = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const ImageSection = styled.div`
  width: 50%;
  background-image: url('/about.jpeg');
  background-size: cover;
  background-position: center;
`;

const AboutContent = styled.div`
  max-width: 32rem;
  line-height: 1.6;
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  color: #374151;
`;

const About = () => {
  return (
    <PageContainer>
      <Navbar />
      <ContentWrapper>
        <TextSection>
          <AboutContent>
            <PageTitle>About Android Sandbox</PageTitle>
            <Paragraph>
              The Android Sandbox is a secure environment for analyzing Android applications.
              Our platform provides detailed analysis of APK files, helping developers and
              security researchers identify potential vulnerabilities and ensure application
              safety.
            </Paragraph>
            <Paragraph>
              Upload your APK files and receive comprehensive reports about their behavior,
              permissions, and potential security concerns. Our automated analysis helps you
              make informed decisions about the applications you develop or use.
            </Paragraph>
            <Paragraph>
              Our cutting-edge technology scans and evaluates APK files for:
              <ul>
                <li>Malware detection</li>
                <li>Permission analysis</li>
                <li>Potential security risks</li>
                <li>Comprehensive code insights</li>
              </ul>
            </Paragraph>
          </AboutContent>
        </TextSection>
        <ImageSection />
      </ContentWrapper>
    </PageContainer>
  );
};

export default About;